import { render, staticRenderFns } from "./ExternalPartnerList.vue?vue&type=template&id=92bfff8a&"
import script from "./ExternalPartnerList.vue?vue&type=script&lang=js&"
export * from "./ExternalPartnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports